<template>
  <!-- PARA REMOVER O MODAL DE EXIBIÇÃO PARA TODOS OS USUÁRIOS, ALTERAR exibeAviso PARA FALSE NO @\store\modules\login.js -->
  <b-modal
    :id="'ModalAtualizacao'"
    no-close-on-backdrop
    no-close-on-esc
    header-class="modal-atualizacao-header"
    body-class="modal-atualizacao-body"
    ok-title="OK"
    footer-class="modal-atualizacao-footer"
    ok-variant="success"
    cancel-title="Não exibir novamente"
    auto-focus-button
    @cancel="removerExibicao"
    @ok="fechaModal"
  >
    <div slot="modal-header" class="title-area modal-atualizacao">
      <font-awesome-icon class="fa-3x" icon="exclamation-circle" />
      <h5 class="modal-title modal-title-atualizacao" id="ModalAdicionarTitulo">Atualização</h5>
    </div>
    <div class="corpo-mensagem">
      <div>
        Prezado(a),
      </div>
      <div>
        A partir de <b>05 de Maio de 2023</b>, visando melhor experiência do usuário e maior
        agilidade em relação ao processamento de dados, os resultados serão gerados separadamente e
        exibidos após a seleção do tributo requerido.
      </div>
      <div>
        O sistema também apresentará todos os possíveis tributos relacionados ao cenário proposto e,
        ao selecioná-los, indicará se haverá ou não previsão legal para a sua aplicação.
      </div>
    </div>
  </b-modal>
</template>

<script>
import Api from "@/services/api.js";

export default {
  name: "ModalAtualizacao",
  props: {
    limpaDadosForm: Function,
    id: Number
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },

  methods: {
    fechaModal() {
      localStorage.setItem("exibeAlertaAtualizacao", false);
    },
    async removerExibicao() {
      await new Api().get("Usuario/updateExibirAviso");
      localStorage.setItem("exibeAlertaAtualizacao", false);
    },
    handleKey(event) {
      let modal = document.getElementById("ModalAtualizacao");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.limpaDadosForm();
          this.$root.$emit("bv::hide::modal", "ModalAtualizacao");
        }
      }
    }
  }
};
</script>

<style lang="scss">
.modal-atualizacao-header {
  color: var(--vermelho3);
  background-color: var(--cinza0) !important;
  border-bottom: 1px solid var(--cinza03) !important;
  text-align: center;
}
.modal-atualizacao-header .modal-atualizacao {
  width: 100%;
}
.modal-atualizacao-header .modal-atualizacao button.close {
  position: absolute;
  top: 16px;
  right: 16px;
}
.modal-atualizacao-header .fa-times-circle {
  font-size: 70px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.modal-atualizacao-body {
  text-align: center;
}
.modal-atualizacao-footer button.btn-secondary {
  background: #9e9e9e !important;
  &:hover {
    background: #777777 !important;
  }
  &:focus {
    background: #777777 !important;
  }
}
.corpo-mensagem {
  text-align: justify !important;
  margin-top: 0px !important;
  float: left;
  width: 100%;
  div {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.modal-atualizacao-footer button.btn-success {
  outline: 0 !important;
  // transition: all 0.3s linear;
  background: #13619c !important;
  &:hover {
    background: var(--azul2) !important;
  }
  &:focus {
    background: var(--azul2) !important;
    &:active {
      box-shadow: 0 0 0 0.2rem #0098da80 !important;
    }
  }
}
.modal-atualizacao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .fa-3x {
    width: 40px;
    height: 40px;
    color: blue;
    margin: 5px;
  }
}
.modal-title-atualizacao {
  margin-bottom: 10px !important;
}
</style>
